import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { RecipientService } from '@pg-app/client/manage-recipient/services/recipient.service';
import { ToastrService } from 'ngx-toastr';
import { VerifyCodeErrorEnum } from '@nttp/enum/verify-code-error-type.enum';
import { RegistrationStep2Service } from '@pg-app/client/services/registrationStep2.service';
import { AuthyTicketTypeEnum } from '@nttp/enum/authy-ticket-type.enum';
import { VerifyTypeSendCodeEnum } from '@nttp/enum/verify-type.enum';
import { SendPaymentInstructionModelService } from '@pg-app/client/send-payment-instruction/services/send-payment-instruction.model.service';
import { Router } from '@angular/router';
import { SendPaymentTypeEnum } from '@nttp/enum/send-payment-type.enum';
import { SendPaymentInstructionComponent } from '@pg-app/client/send-payment-instruction/containers/send-payment/send-payment-instruction.component';
import { SendPaymentModalComponent } from '@pg-app/client/client-dashboard/components/send-payment-modal/send-payment-modal.component';

@Component({
  selector: 'np-verify-passcode',
  templateUrl: './verify-passcode.component.html',
  styleUrls: ['./verify-passcode.component.scss']
})
export class VerifyPasscodeComponent {
  btnName = 'Continue';
  email = '';
  pinCodeError = null;
  ticketType = AuthyTicketTypeEnum.CreateRecipient;
  sendOnetouchSuccess = false;

  constructor(
    public dialogRef: MatDialogRef<VerifyPasscodeComponent>,
    private recipientService: RecipientService,
    public dialog: MatDialog,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public registerService: RegistrationStep2Service,
    private paymentModel: SendPaymentInstructionModelService,
    private router: Router
  ) {}

  sendPassCode(event = null) {
    this.pinCodeError = null;
    const method = event ? event.method : VerifyTypeSendCodeEnum.Authy;
    this.recipientService.sendPassCode(method).subscribe(
      res => {
        if (!event) {
          this.sendOnetouchSuccess = true;
        }
        if (event && event.isTryAgain) {
          this.pinCodeError = VerifyCodeErrorEnum.ResendCode;
        }
      }
    );
  }

  updateRecipient() {
    this.recipientService.updateRecipientBanks(this.data).subscribe(
      _res => {
        // If not update beneficiary from send payment
        // or if select mandate option after fund account
        // and set mandate is no in update beneficiary
        // do nothing
        if (!this.paymentModel.manageRecipientFromPayment
          || (this.paymentModel.step === this.paymentModel.sendPaymentStep.paymentMandate
            && !this.data.receipient.paymentMandate)) {
          this.dialogRef.close(_res);
          return;
        }

        // else back to dashboard
        this.router.navigate(['/client/dashboard']);
        // if send payment to mandate keep step mandate
        if (this.paymentModel.step !== this.paymentModel.sendPaymentStep.paymentMandate) {
          this.paymentModel.selectedRecipient.id = _res;
          this.paymentModel.step =
          this.paymentModel.tradeList.length > 0
            ? this.paymentModel.sendPaymentStep.balanceTradeAvailable
              : this.paymentModel.sendPaymentStep.paymentConfirmation;
        }

        const component =
        this.paymentModel.sendPaymentType === SendPaymentTypeEnum.SendPaymentFromTrade || this.paymentModel.step === this.paymentModel.sendPaymentStep.paymentMandate
          ? SendPaymentInstructionComponent
          : SendPaymentModalComponent;

        this.dialog.open(component, {
          disableClose: true,
          panelClass: 'custom-dialog'
        });
        this.dialogRef.close(_res);
      },
      _err => {
        this.dialogRef.close(false);
      }
    );
  }

  confirmPassCode(event) {
    this.pinCodeError = null;
    this.recipientService.verificationPassCode(event.code, event.verificationType).subscribe(
      res => {
        this.updateRecipient();
      },
      err => {
        this.pinCodeError = VerifyCodeErrorEnum.InvalidCode;
      }
    );
  }
}
